/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_FeeInputs */

const en_platform_fee = /** @type {(inputs: Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform Fee`)
};

const es_platform_fee = /** @type {(inputs: Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comisión de plataforma`)
};

const fr_platform_fee = /** @type {(inputs: Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frais de plateforme`)
};

const de_platform_fee = /** @type {(inputs: Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformgebühr`)
};

const ja_platform_fee = /** @type {(inputs: Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラットフォーム手数料`)
};

const zh_platform_fee = /** @type {(inputs: Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台费`)
};

const ar_platform_fee = /** @type {(inputs: Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رسوم المنصة`)
};

const id_platform_fee = /** @type {(inputs: Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya Platform`)
};

const it_platform_fee = /** @type {(inputs: Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commissione di Piattaforma`)
};

const ru_platform_fee = /** @type {(inputs: Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Комиссия платформы`)
};

const pt_platform_fee = /** @type {(inputs: Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de Plataforma`)
};

const ko_platform_fee = /** @type {(inputs: Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랫폼 수수료`)
};

/**
* | output |
* | --- |
* | "Platform Fee" |
*
* @param {Platform_FeeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const platform_fee = /** @type {((inputs?: Platform_FeeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_FeeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_platform_fee(inputs)
	if (locale === "es") return es_platform_fee(inputs)
	if (locale === "fr") return fr_platform_fee(inputs)
	if (locale === "de") return de_platform_fee(inputs)
	if (locale === "ja") return ja_platform_fee(inputs)
	if (locale === "zh") return zh_platform_fee(inputs)
	if (locale === "ar") return ar_platform_fee(inputs)
	if (locale === "id") return id_platform_fee(inputs)
	if (locale === "it") return it_platform_fee(inputs)
	if (locale === "ru") return ru_platform_fee(inputs)
	if (locale === "pt") return pt_platform_fee(inputs)
	return ko_platform_fee(inputs)
});